import '../scss/styles.scss';
import { scrollToTop } from '../utils';
import handleFrontPageCacheMiss from './handleFrontPageCacheMiss';
import NrpFrontPageData from '../../types/NrpFrontPageData';
import countdownService from '../services/countdownService';

declare const nrpFrontPageData: NrpFrontPageData;

(({ articleData }) => {
  document.addEventListener('DOMContentLoaded', () => {
    scrollToTop();

    if (articleData) {
      // check out for param in url frontPageLive
      const frontPageLive = window.location.search.includes('frontPageLive');
      if (frontPageLive) {
        return;
      }

      countdownService.initCountdowns(articleData);
    }
  });
  handleFrontPageCacheMiss();
})(nrpFrontPageData);
